module.exports = __webpack_public_path__ + "static/media/close.effd8318.svg";